
import EDMenuButton from '../../../../../BaseComponents/Buttons/MenuButton/EDMenuButton';
import EDIcon from '../../../../../BaseComponents/Icon/EDIcon';
import { ElementType } from '../../../../../BaseComponents/LocalMenu/EDLocalMenu';
import { IClientBusinessModel } from '../../../../../Types/ClientModelTypes';

export interface IMenuProps {
  id: string;
  collection?: IClientBusinessModel;
  className?: string;
  highEmphasis?: boolean;
  children?: ElementType;
  disabled?: boolean;
  buttonHighEmphasis?: boolean;
}

const FunctionMenu: React.FunctionComponent<
  React.PropsWithChildren<IMenuProps>
> = props => {
  return (
    <EDMenuButton
      iconColor="inherit"
      tooltip="Funktioner"
      icon={<EDIcon color="inherit" iconType="more_vert" size="medium" />}
      buttonHighEmphasis={props.highEmphasis}
      highEmphasis={props.highEmphasis}
      disabled={props.disabled}
      noClickPropagation
    >
      {props.children}
    </EDMenuButton>
  );
};

export default FunctionMenu;
